import React from 'react';
import CustomButton from '../OnboardingComponents/CustomButton';
import { ICONS } from '../../constants/icons';

/**
 * CalendarToolbar — All/My Tasks toggle + month nav + Today / Setup Calendar.
 */
const CalendarToolbar = ({
  filter = 'all',
  onFilterChange,
  monthLabel = 'July 2026',
  onPrevMonth,
  onNextMonth,
  onToday,
  onSetupCalendar,
  canManageCalender = true
}) => (
  <div className="project-calendar-toolbar">
    {canManageCalender && (
    <div className="project-calendar-toolbar__filter" role="group" aria-label="Task filter">
      <button
        type="button"
        className={`project-calendar-toolbar__pill ${
          filter === 'all' ? 'project-calendar-toolbar__pill--active' : ''
        }`}
        onClick={() => onFilterChange?.('all')}
      >
        All Tasks
      </button>
      <button
        type="button"
        className={`project-calendar-toolbar__pill ${
          filter === 'my' ? 'project-calendar-toolbar__pill--active' : ''
        }`}
        onClick={() => onFilterChange?.('my')}
      >
        My Tasks
      </button>
    </div>
    )}

    <div className="project-calendar-toolbar__nav">
      <button
        type="button"
        className="project-calendar-toolbar__chevron"
        onClick={onPrevMonth}
        aria-label="Previous month"
      >
        <img src={ICONS.chevronLeft} alt="" />
      </button>
      <span className="project-calendar-toolbar__month">{monthLabel}</span>
      <button
        type="button"
        className="project-calendar-toolbar__chevron"
        onClick={onNextMonth}
        aria-label="Next month"
      >
        <img src={ICONS.chevronRight} alt="" />
      </button>
      <div className="project-calendar-toolbar__cta">
        <button
          type="button"
          className="project-calendar-toolbar__today"
          onClick={onToday}
        >
          Today
        </button>
        {canManageCalender && (
        <CustomButton
          variant="primary"
          size="sm"
          className="project-calendar-toolbar__setup"
          trailingIconSrc={ICONS.calendar}
          trailingIconAlt=""
          onClick={onSetupCalendar}
        >
          Setup Calendar
        </CustomButton>
        )}
      </div>
    </div>
  </div>
);

export default CalendarToolbar;
